import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Components
import TestimonialBox from "../Elements/TestimonialBox";

export default function TestimonialSlider() {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true, // Enable auto slide
    autoplaySpeed: 3000, // Set speed for each slide (in milliseconds)
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div>
      <Slider {...settings}>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="This service has been an amazing experience in my life. It helped our team improve professional skills and led to more success."
            author="Nihal Perera"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="The service provided has been incredibly clean and helpful. I received security, trust, and proactive service from the team."
            author="Arunilla Wijerathna"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="Their team, products, and services are exceptional. I was able to get the support I needed for all my tasks and projects."
            author="Theja Ranasinghe"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="The solutions provided were quick and fair. I could achieve my goals successfully thanks to their efficient support."
            author="Saman Prasad"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="Their service team delivered the best products with clear and valuable insights, guiding us through the entire process."
            author="Madushani Rathnayake"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="They managed our service and transactions very efficiently, allowing us to achieve everything we needed quickly."
            author="Chathuri Puwane"
          />
        </LogoWrapper>
      </Slider>
    </div>
  );
}

const LogoWrapper = styled.div`
  width: 90%;
  padding: 0 5%;
  cursor: pointer;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;
